import { Dialog } from "@themes/pollinator/ui/Dialog";
import { UserWithProfile } from "@core/features/auth";
import { ProgramCircleParticipant } from "@platform/features/programCircle";
import { Loader } from "@themes/pollinator/ui/Loader";

export type Props = {
  participants?: UserWithProfile[];
  isOpen: boolean;
  onClose: () => void;
};

export function ProgramCircleParticipantsDialog({
  participants,
  isOpen = true,
  onClose,
}: Props) {
  return (
    <Dialog
      title="Your Peer Cohort"
      isOpen={isOpen}
      onClose={onClose}
      containerClassName="gap-0"
      className="p-0 md:p-0"
      size="4xl"
    >
      {participants ? (
        <div className="flex flex-row flex-wrap w-full">
          {participants.map((participant) => (
            <ProgramCircleParticipant
              key={participant.id}
              participant={participant}
              className="basis-full md:basis-1/2"
            />
          ))}
        </div>
      ) : (
        <Loader isAbsolute />
      )}
    </Dialog>
  );
}

export default ProgramCircleParticipantsDialog;

